import { IRetentionInfo } from "types/retentionInfoType"

export const RENTENTION_TYPES: IRetentionInfo[] = [
  {
    retentionType: "IVA",
    percent: "75%",
    baseKey: "baseIva16",
    retKey: "retIva75",
  },
  {
    retentionType: "ISLR",
    percent: "2%",
    baseKey: "baseRet2",
    retKey: "retISLR2",
  },
  {
    retentionType: "ISLR",
    percent: "3%",
    baseKey: "baseRet3",
    retKey: "retISLR3",
  },
]
